import { FloatingLabel } from "../common/components/FloatingLabel";
import { realizeJob, useJob } from "../reducers/jobSlice";
import PropTypes from 'prop-types';
import { useRequestableJob } from "../reducers/requestableJobsSlice";

export const customCtrlDef = {
    toString: async ({ value, defaultValue, ...props }) => {
        if (value) {
            const job = await realizeJob({ ...props }, value);
            return job?.displayid ?? defaultValue;
        }
        return defaultValue;
    },
    control: ({ value, placeholder, hideLabel, ...props }) => <FloatingLabel value={value} hideLabel={hideLabel}><JobIDLabel jobid={value} placeholder={placeholder} {...props}></JobIDLabel></FloatingLabel>
}

export const RequestableJobIDLabel = ({ jobid }) => {
    const job = useRequestableJob(jobid);
    return job?.displayid;
}

const JobIDLabel = ({ jobid }) => {
    const job = useJob(jobid);

    return job.displayid;
}
JobIDLabel.propTypes = {
    jobid: PropTypes.string
}

export default JobIDLabel